import { Component, Input } from '@angular/core';
import { BaseCinchCardComponent } from '../base-cinch-card.component';
import { PrimeNGModule } from '../../prime-ng.module';

@Component({
  selector: 'cinch-card',
  templateUrl: './cinch-card.component.html',
  styleUrl: '../base-cinch-card.component.scss',
})
export class CinchCardComponent extends BaseCinchCardComponent {
}
